export default function ReadonlyModeHttpRequestInterceptor($rootScope, $q) {
  'ngInject';

  return {
    request(config) {
      if (
        $rootScope.readonlyMode &&
        config.method !== 'GET' &&
        !(config.url.endsWith('/account/login') && config.method === 'POST') && // logging in
        !(config.url.endsWith('/account/session') && config.method === 'PUT')
      ) {
        // changing org
        config.readonlyModeErrorMessage =
          'Sling is in read-only mode. This operation is not possible right now. Try again later.';
        config.timeout = $q.resolve(config.readonlyModeErrorMessage);

        // this request is being made every time dashboard is opened and it would be strange
        // for a user that opening dashboard resulted in an error
        if (config.url.endsWith('/notifications/read') && config.method === 'PUT') {
          config.ignoreGlobalErrorHandler = true;
        }
      }
      return config;
    },
    responseError(resp) {
      if (resp.config?.readonlyModeErrorMessage) {
        resp.statusText = resp.config.readonlyModeErrorMessage;
        resp.data = {};
      }
      return $q.reject(resp);
    },
  };
}
